// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import * as yup from "yup";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import Button from "@mui/material/Button";
import { useDynamicTranslation } from "@/hooks/useDynamicTranslation";
import { Form } from "../form";
import { Grid } from "../grid";

export function DefaultEditForm({ columns, row, handleRowUpdate }: any) {
  const { t } = useDynamicTranslation("shared");
  const [loading, setLoading] = useState();

  const handleSubmit = async (values: any) => {
    setLoading(true);
    await handleRowUpdate(values);
    setLoading(false);
  };

  const validationSchema = useMemo(() => {
    const validationObject = {};
    columns.forEach((column: any) => {
      validationObject[column.field] = column.validation;
    });

    return yup.object().shape(validationObject);
  }, [columns]);

  const getFormItemByColumn = (column: any) => {
    const params = {
      name: column.field,
      label: column.headerName,
      helperText: column.description,
      readonly: !column.editable,
    };

    if (column.type === "number" || column.type === "currency") {
      return <Form.TextField {...params} type="number" />;
    }

    if (column.type === "boolean") {
      return <Form.Switch {...params} />;
    }

    if (column.type === "enum") {
      return <Form.Select {...params} options={column.options} />;
    }

    if (column.type === "date") {
      return <Form.DatePicker {...params} />;
    }

    return <Form.TextField {...params} />;
  };

  return (
    <Form
      sx={{ p: 5, textAlign: "center" }}
      loading={loading}
      initialValues={row}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <Grid direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={4}>
        {columns.map((column: any) => (
          <Grid.Item key={column.field} xs={6}>
            {getFormItemByColumn(column)}
          </Grid.Item>
        ))}
      </Grid>
      <Button sx={{ mt: 5 }} variant="contained" type="submit">
        {t("save")}
      </Button>
    </Form>
  );
}

DefaultEditForm.propTypes = {
  columns: PropTypes.array.isRequired,
  row: PropTypes.object.isRequired,
  handleRowUpdate: PropTypes.func.isRequired,
};
